<div class='wrapperTitleAndNavigationForProfile'>
  <headTitle text='Settings' typeText='text2-blueDark' svgLeft='arrow_squareLeft&24'
             (svgLeftEmit)='otherS.locationBack()'></headTitle>
  <app-dropdown *ngIf='showNavigation' [ngModel]='(profileS.currentSubLink$|async)!'
                [array]='(profileS.arrLinkObj$|async)!'
                (changeValObj)='profileS.navigateProfile($event,typePageProfile,idUser)'></app-dropdown>
</div>